<template>
	<div class="custom-loader custom-loader-absolute w-100 h-100 d-flex align-items-center justify-content-center">
	  <div>
	      <img class="escudo" v-if="manager" :src="manager.logo" style="max-height: 150px;">
	      <img class="oval" src="https://storage.compralaentrada.com/images/oval.svg" />
	  </div>
	</div>
</template>

<script>
export default {
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        manager() {
            return this.$store.getters.getFooter;
        }
    }
}
</script>

<style scoped>
    .oval {
        background-color: rgba(250, 250, 250, 0.5);
        border-radius: 4em;
    }
</style>